import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

import IneligibleExceptionsStep, {
	IIneligibleExceptionsStepPageContent,
} from './IneligibleExceptionsStep.component';

interface IIneligibleExceptionsStepPageProps extends IFlowStepProps {}

const IneligibleExceptionsStepPage: FC<IIneligibleExceptionsStepPageProps> = ({
	path,
	stepKey,
}) => {
	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "mh-exceptional-conditions-ineligibility" }) {
				page_headline
				liver_disease_header
				liver_disease_body
				hormone_cancer_header
				hormone_cancer_body
				prolactin_header
				prolactin_body
				vc_cta_header
				vc_cta_body
				back_button_label
				vc_cta_label
				return_to_folx_label
			}
		}
	`);

	const context = useContext(FlowContext);
	const { handleNavBack } = context;

	const refinedContent: IIneligibleExceptionsStepPageContent = keysToCamel(
		pageContent
	) as IIneligibleExceptionsStepPageContent;

	return (
		<IneligibleExceptionsStep
			path={path}
			stepKey={stepKey}
			handleNavBack={handleNavBack}
			pageContent={refinedContent}
		/>
	);
};

export default IneligibleExceptionsStepPage;
